import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { NewFormData } from '@/interfaces/components/clients/NewFormData';
import { AccountingLocations } from '@/enums/global/AccountingLocations';

interface Props {
  modelValue?: NewFormData;
  shipmentMethods?: any[];
  transactionTypes?: any[];
  transportationTypes?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryInformation',
  props: {
    modelValue: null,
    shipmentMethods: null,
    transactionTypes: null,
    transportationTypes: null
  },
  emits: [
  'update:shipmentMethod',
  'update:location',
  'update:transactionType',
  'update:transportationType',
],
  setup(__props: any) {

const props = __props as {
  modelValue?: NewFormData;
  shipmentMethods?: any[];
  transactionTypes?: any[];
  transportationTypes?: any[];
};





function getValue(key: keyof NewFormData) {
  const val = props.modelValue?.[key];
  return val != null ? String(val) : undefined;
}

const location = computed(() => props.modelValue?.location);

const locationOptions = computed(() => [
  { label: AccountingLocations.DOMESTIC, value: AccountingLocations.DOMESTIC },
  { label: AccountingLocations.EU, value: AccountingLocations.EU },
]);


function useFormattedOptions(listProp: keyof Props) {
  return computed(() => {
    const list = props[listProp] as any[];
    return (list ?? []).map((item) => ({
      label: `(${item.code}) ${item.description}`,
      value: String(item.id),
    }));
  });
}

const formattedShipmentMethods = useFormattedOptions('shipmentMethods');
const formattedTransactionTypes = useFormattedOptions('transactionTypes');
const formattedTransportationTypes = useFormattedOptions('transportationTypes');

return { __sfc: true,props, getValue, location, locationOptions, useFormattedOptions, formattedShipmentMethods, formattedTransactionTypes, formattedTransportationTypes }
}

})